import React from "react";
import JoRequests from "../accounting/JoRequests";

const AdminJoRequests = () => (
  <JoRequests
    portalLabel="Admin Portal"
    pageTitle="JO Requests"
    pageDescription="Monitor active and nomination job orders and confirm whether each JO already has a submitted request."
  />
);

export default AdminJoRequests;
